export default __webpack_public_path__ + "static/media/loader.020a7025.gif";